import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "err-text" }

import { watch, ref } from "vue";

const __default__ = {
  name: "GlobalNetworkErrorDialog",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  // 控制是否显示错误弹窗
  showError: {
    type: Boolean,
    default: false,
  },
  // 错误信息文案
  errorDesc: {
    type: String,
    default: "",
  },
},
  emits: ["update:showError", "onClose"],
  setup(__props, { emit: emits }) {

const props = __props




const _showError = ref<boolean>(props.showError);

const onClose = () => {
  emits("onClose");
  emits("update:showError", !props.showError);
};

watch(
  () => props.showError,
  (newVal) => {
    _showError.value = newVal;
  }
);

watch(
  () => _showError.value,
  (newVal) => {
    emits("update:showError", newVal);
  }
);

return (_ctx: any,_cache: any) => {
  const _component_mas_modal = _resolveComponent("mas-modal")!

  return (_openBlock(), _createBlock(_component_mas_modal, {
    visible: _showError.value,
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_showError).value = $event)),
    customFooterBtns: "",
    closeIcon: "",
    onClose: onClose
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(__props.errorDesc), 1)
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})